import { Field, Formik } from 'formik'
import { AvatarSelector, ModalForm } from 'modules/app/styles'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { FormGroup, Input, Label, Modal, ModalBody, ModalFooter } from 'reactstrap'
import * as yup from 'yup'
import { ReactComponent as SharpIcon } from 'assets/images/icons/sharp.svg'
import { ReactComponent as CloseIcon } from 'assets/images/icons/close.svg'
import { CustomButton } from 'modules/auth/styles'
import { ButtonLoader } from 'utils/storageUtils'
import { checkImageUploadType, handleApiError, logAmplitudeEvent, removeMediaFromSpaces, uploadtoSpaces } from 'utils/helpers'
import { ReactSelectStyled } from 'modules/app/styles'
import { deleteCompanyMember_api, updateProfile_api } from 'store/apis'
import { history } from 'store/store'
import { toggleSettingsModal_action, logout_action, restoreSession } from 'store/actions'

export const ProfileSetting = (props) => {
  const { user, members } = props
  const [is_submitting, set_is_submitting] = useState(false)
  const [saved, set_saved] = useState(false)
  const [previewAvatar, set_previewAvatar] = useState(user.avatar)
  const [avatarFile, set_avatarFile] = useState(null)
  const [showRemoveMyAccountModal, set_showRemoveMyAccountModal] = useState(false)
  const [newOwner, set_newOwner] = useState(null)
  const [showOwnerError, set_showOwnerError] = useState(false)
  const [is_removing, set_is_removing] = useState(false)
  const [showRemoveAccountSuccess, set_showRemoveAccountSuccess] = useState(false)
  const [cancelSubscriptionNow, set_cancelSubscriptionNow] = useState(false)
  const [_members, set_members] = useState([])

  useEffect(() => {
    set_members(members.filter((m) => m.is_active && m.invite_status === 'added'))
  }, [members])

  const onChangeAvatar = (e) => {
    const file = e.target.files[0]
    if (file && checkImageUploadType(file.type)) {
      var reader = new FileReader()
      reader.onload = (e) => {
        set_previewAvatar(e.target.result)
        set_avatarFile(file)
      }
      reader.readAsDataURL(file)
    } else {
      handleApiError('Invalid image')
    }
  }
  const removePreview = (e) => {
    e.preventDefault()
    set_previewAvatar(null)
    set_avatarFile(null)
    const fileElem = document.querySelector('#avatar')
    if (fileElem) {
      fileElem.value = ''
    }
  }
  const onConfirmRemoveAccount = async () => {
    try {
      if (props.user.membership.invite_status === 'owned') {
        if (_members.length > 0 && (!newOwner || !newOwner.value)) {
          set_showOwnerError(true)
          return
        }
        set_is_removing(true)
        await deleteCompanyMember_api(props.user.member_code, { assign_to: newOwner?.value, cancelSubscriptionNow })
      } else {
        set_is_removing(true)
        await deleteCompanyMember_api(props.user.member_code)
      }
      logAmplitudeEvent('Account removed')
      set_showRemoveMyAccountModal(false)
      set_showRemoveAccountSuccess(true)
      setTimeout(() => {
        props.toggleSettingsModal(false)
        props.onLogout()
        history.push('/register')
      }, 1500)
    } catch (error) {
      handleApiError(error)
    }
    set_is_removing(false)
  }
  return (
    <>
      <ModalBody>
        <Formik
          enableReinitialize
          initialValues={{
            previewAvatar: previewAvatar,
            avatar: previewAvatar,
            name: user.name,
            position: user.membership.position
          }}
          validationSchema={yup.object().shape({
            name: yup.string().required()
          })}
          onSubmit={async (values) => {
            try {
              set_is_submitting(true)
              const data = { ...values }

              // Uplaod logo if add / changed
              if (avatarFile) {
                // If changed, remove the older one
                if (user.avatar) {
                  removeMediaFromSpaces(user.avatar)
                }
                const link = await uploadtoSpaces(process.env.REACT_APP_DO_SPACES_PROFILES, avatarFile)
                data.avatar = link
              }
              // If Logo Removed
              else if (user.avatar && !previewAvatar) {
                removeMediaFromSpaces(user.avatar)
              }

              delete data.previewAvatar
              await updateProfile_api(data)
              set_saved(true)
              props.restoreSession(true)
            } catch (error) {
              handleApiError(error)
            }
            set_is_submitting(false)
            setTimeout(() => {
              set_saved(false)
            }, 2000)
          }}>
          {(formikProps) => (
            <ModalForm onSubmit={formikProps.handleSubmit} autoComplete='off' style={{ maxWidth: 400 }}>
              <div className='title'>Profile</div>
              <br />
              <br />
              <FormGroup className='mb-5'>
                <AvatarSelector htmlFor='avatar'>
                  {formikProps.values.avatar && (
                    <a href='/' className='remove' onClick={removePreview}>
                      <CloseIcon />
                    </a>
                  )}
                  <input type='file' name='avatar' onChange={onChangeAvatar} id='avatar' accept='image/jpeg, image/jpg, image/png' />
                  <div className='preview'>
                    {previewAvatar && <img src={previewAvatar} alt='' />}
                    {!previewAvatar && <SharpIcon className='placeholder' />}
                  </div>
                  {!previewAvatar && <div className='upload-logo-placeholder'>Upload Avatar</div>}
                </AvatarSelector>
              </FormGroup>
              <FormGroup className='mb-5'>
                <Label>Email: </Label>
                <div className='font-weight-600'> {user.email} </div>
              </FormGroup>
              <Field name='name'>
                {({ field }) => (
                  <FormGroup className='mb-5'>
                    <Label>Full Name</Label>
                    <Input {...field} className={formikProps.errors.name ? 'error' : ''} />
                  </FormGroup>
                )}
              </Field>
              <Field name='position'>
                {({ field }) => (
                  <FormGroup className='mb-5'>
                    <Label>Position</Label>
                    <Input {...field} className={formikProps.errors.position ? 'error' : ''} />
                  </FormGroup>
                )}
              </Field>
              <div className='d-flex mb-5'>
                <CustomButton type='submit' className={`${!saved ? 'black' : 'green'}`} disabled={is_submitting || saved}>
                  {saved ? 'Saved' : 'Update'} {is_submitting && <ButtonLoader />}
                </CustomButton>
                <CustomButton type='button' className='gray shadow-none ml-3' onClick={() => props.set_showChangePassword(true)}>
                  Set New Password
                </CustomButton>
              </div>
              <a
                href='/'
                className='text-danger'
                onClick={(e) => {
                  e.preventDefault()
                  set_showRemoveMyAccountModal(true)
                }}>
                Delete my account
              </a>
            </ModalForm>
          )}
        </Formik>
      </ModalBody>
      {showRemoveMyAccountModal && (
        <Modal isOpen centered fade={false} toggle={() => set_showRemoveMyAccountModal(false)}>
          <ModalBody>
            {props.user.membership.invite_status === 'owned' && (
              <>
                <div className='mb-2 font-weight-600'>You're about to delete your account.</div>
                {_members.length > 0 && (
                  <div>
                    <p className='mb-4'>
                      Since you own this team, before removing your account you need to transfer the ownership to another user.
                      <br />
                    </p>
                    <div className='d-flex align-items-center'>
                      <div className={`font-weight-600 mr-3 ${showOwnerError && 'text-danger'}`}>Please select the new owner:</div>
                      <div style={{ width: 200 }}>
                        <ReactSelectStyled
                          className='select-control'
                          classNamePrefix='select-control'
                          value={newOwner}
                          onChange={(obj) => {
                            set_showOwnerError(false)
                            set_newOwner(obj || null)
                          }}
                          options={_members.map((u) => ({ value: u.member_code, label: `${u.name} (${u.user_type})` }))}
                          placeholder=''
                        />
                      </div>
                    </div>
                    {props.is_subscribed && !props.subscription.cancel_at_period_end && (
                      <FormGroup check className='p-0 mt-4'>
                        <Label check className='mr-4'>
                          <Input type='checkbox' name='radio1' checked={cancelSubscriptionNow} value='normal' onChange={(e) => set_cancelSubscriptionNow(e.target.checked)} />
                          <span>I want to downgrade the subscription to Free</span>
                        </Label>
                      </FormGroup>
                    )}
                  </div>
                )}
                {_members.length === 0 && (
                  <div className='mb-2'>
                    Since you are the only member on your account, it will be deleted and no longer be accessible.
                    {props.is_subscribed && !props.subscription.cancel_at_period_end && <span>Your Pro plan will be canceled, and there won't be further charges.</span>}
                  </div>
                )}
              </>
            )}
            {props.user.membership.invite_status !== 'owned' && (
              <>
                <div className='mb-2 font-weight-600'>You're about to delete your account.</div>
                <p>This action can't be reverted in future.</p>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <CustomButton className='black' onClick={onConfirmRemoveAccount} disabled={is_removing}>
              Confirm {is_removing && <ButtonLoader />}
            </CustomButton>
            <CustomButton
              className='gray mr-3 shadow-none'
              onClick={() => {
                set_showOwnerError(false)
                set_newOwner(null)
                set_showRemoveMyAccountModal(false)
              }}>
              Cancel
            </CustomButton>
          </ModalFooter>
        </Modal>
      )}
      {showRemoveAccountSuccess && (
        <Modal isOpen centered fade={false}>
          <ModalBody className='text-center'>
            <h3 className='mb-3'>We'll miss you...</h3>
            <h3>Good luck :)</h3>
          </ModalBody>
        </Modal>
      )}
    </>
  )
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  members: state.company.company.members,
  subscription: state.subscription.subscription,
  is_subscribed: state.subscription.is_subscribed
})

const mapDispatchToProps = (dispatch) => ({
  onLogout: () => dispatch(logout_action()),
  restoreSession: () => dispatch(restoreSession()),
  toggleSettingsModal: (status) => dispatch(toggleSettingsModal_action(status))
})

export default connect(mapStateToProps, mapDispatchToProps)(ProfileSetting)
